import {
  GENERAL_CONTRACTORS_LOAD_SUCCESS,
  GENERAL_CONTRACTOR_LOAD_SUCCESS,
  GENERAL_CONTRACTOR_PROJECTS_LOAD_SUCCESS,
  GENERAL_CONTRACTORS_USERS_SET,
} from 'components/admin/general-contractors/store/action-types';

const initialState = {
  generalContractors: { data: [], total: 0 },
  currentGeneralContractor: null,
  projects: null,
  users: [],
};

export default function generalContractorsDataReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GENERAL_CONTRACTOR_LOAD_SUCCESS:
      return {
        ...state,
        currentGeneralContractor: action.payload,
      };

    case GENERAL_CONTRACTORS_LOAD_SUCCESS:
      return {
        ...state,
        generalContractors: action.payload,
      };

    case GENERAL_CONTRACTOR_PROJECTS_LOAD_SUCCESS:
      return {
        ...state,
        projects: action.payload,
      };

    case GENERAL_CONTRACTORS_USERS_SET:
      return {
        ...state,
        users: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/general-contractors/store/reducers.data.js